
export enum DisputeDecisionReasonTypeCd {
	AMEND = 'Amend',
	APPROVE = 'Approve',
	CANCEL = 'Cancel',
	DECLINE = 'Decline'}

